<script setup>
import { isSaving, errorMessage, isDeleting, undoUrl } from '@/savingState';
import { ref } from 'vue';
const isUndoing = ref(false);
</script>

<template>
    <div v-if="isSaving" class="z-50 fixed top-0 left-0 bg-transparent w-full flex justify-center">
        <div
            cy-test="saving-indicator"
            class="text-theme-500 rounded-full py-1 px-4 mt-4 bg-white/80 border-theme-500 border max-w-sm"
        >
            Saving...
        </div>
    </div>

    <div v-else-if="isDeleting || undoUrl" class="z-50 fixed top-0 left-0 bg-transparent w-full flex justify-center">
        <div v-if="isUndoing" class="text-red-500 rounded-full py-1 px-4 mt-4 bg-white/80 border-red-500 border max-w-sm">
            Undoing...
        </div>
        <div
            v-else
            cy-test="deleting-indicator"
            class="text-red-500 rounded-full py-1 px-4 mt-4 bg-white/80 border-red-500 border max-w-sm"
        >
            {{ isDeleting ? 'Deleting...' : 'Deleted.' }}
            <a v-if="undoUrl" :href="undoUrl" @click="isUndoing = true" class="ml-4 cursor-pointer underline">Undo</a>
        </div>
    </div>

    <div v-if="errorMessage" class="z-50 fixed top-0 left-0 bg-transparent w-full flex justify-center">
        <div class="text-red-500 rounded-md py-1 px-4 mt-4 bg-white/80 border-red-500 border max-w-sm">
            <p><span class="font-bold">Error: </span>{{ errorMessage }}</p>
            <p class="font-bold">Try reloading the page.</p>
        </div>
    </div>
</template>
